import * as aTypes from '../../action-types'
import * as mTypes from '../../mutation-types'
import api from '../../../api'
import { fetchFormItems } from '../../../utils'

/*
const sampleDetail = {
  index: 23,
  count: 99,

  amount: 999456,
  status: {
    success: true,
    channel: '微信支付'
  },
  phone: '12311112222',
  mail: 'abcabc@defdefff.com'
}
*/

const state = {
  index: 0,
  count: 0,

  amount: 0,
  status: {
    success: false,
    channel: ''
  },
  statusText: '',

  rows: []
}

const actions = {
  [aTypes.CF_GET_FEEDBACK_DETAIL] ({ commit }, { contactId, projectId, donateId }) {
    commit(mTypes.SET_LOADING, { key: aTypes.CF_GET_FEEDBACK_DETAIL, loading: true })
    api.cf.getFeedbackDetail({
      success (res) {
        const body = res.body
        const detail = {
          index: body.position.current,
          count: body.position.total,

          amount: body.donate_amount,
          status: {
            success: body.status === 'paid',
            channel: body.pay_channel // '微信支付'
          },
          statusText: body.status_text,

          rows: fetchFormItems(body.project.form_items, body.donate_form_data)

          // name: body.donate_form_data ? body.donate_form_data.name : (body.contact ? body.contact.name : '无'),
          // phone: body.donate_form_data ? body.donate_form_data.mobile : (body.contact ? body.contact.mobile : '无'),
          // mail: body.donate_form_data ? body.donate_form_data.email : (body.contact ? body.contact.email : '无')
        }
        commit(mTypes.CF_SET_FEEDBACK_DETAIL, detail)
        commit(mTypes.SET_NAV_TITLE, res.body.project.title)
        commit(mTypes.SET_PAGINATION, {
          prevTo: body.prev_record_id ? {
            path: '/main/cf/feedback-detail',
            query: {
              contactId,
              projectId,
              donateId: body.prev_record_id
            }
          } : null,
          nextTo: body.next_record_id ? {
            path: '/main/cf/feedback-detail',
            query: {
              contactId,
              projectId,
              donateId: body.next_record_id
            }
          } : null
        })
        commit(mTypes.SET_LOADING, { key: aTypes.CF_GET_FEEDBACK_DETAIL, loading: false })
      },
      commit
    }, { contactId, projectId, donateId })
  }
}

const mutations = {
  [mTypes.CF_SET_FEEDBACK_DETAIL] (state, detail) {
    state.index = detail.index
    state.count = detail.count
    state.amount = detail.amount
    state.status = detail.status
    state.statusText = detail.statusText
    state.rows = detail.rows
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cf/feedbackDetail.js